import { Card, CardContent } from '@mui/material';

export default function PropertyType({ type }) {
  let typeString;
  switch (type) {
    case 'real':
      typeString = 'Real Property';
      break;
    case 'personal':
      typeString = 'Personal Property';
      break;
    case 'greenbelt':
      typeString = 'Greenbelt Property';
      break;
    case 'vehicle':
      typeString = 'Motor Vehicle';
      break;
    default:
      typeString = 'Unknown Property Type';
  }

  return (
    <>
      <div className="flex flex-wrap">
        <Card>
          <CardContent>
            <div
              className={typeString != 'Unknown Property Type' ? '' : 'text-red-600'}
              data-cy="property-type"
            >
              {typeString}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
